module.exports = __webpack_public_path__ + "posture/static/img/cooperation-logo.593817a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/cooperation-logo.png
// module id = iT//
// module chunks = 1